import React, { useEffect, useState } from 'react';

import MetabaseDashboard from '../components/MetabaseDashboard';

import { getTherapyRefusalMetabaseDashboard } from '../../modules/metabase_dashboard.js';

const TherapyRefusalDashboard = () => {
  const [dashboardURL, setDashboardURL] = useState('');
  useEffect(() => {
    (async () => {
      const dashboardResponse = await getTherapyRefusalMetabaseDashboard();

      if (dashboardResponse && dashboardResponse.data && dashboardResponse.data.success) {
        setDashboardURL(dashboardResponse.data.dashboard_url);
      }
    })();
  }, []);

  return <MetabaseDashboard dashboardURL={dashboardURL} />;
};

export default TherapyRefusalDashboard;
